
export interface TokenData {
    accesstoken: string;
    refreshtoken: string;
    type?: string;
    expires_at?: Date;
}

export class UserData {
  isUserLoggedIn = false;
  clientId: string;
  tenantId: string;
  tenant: string;
  emailId: string;
  userId: string;
  userName: string;
  groupId: string;
  roleId: number;
  accessType: string;
  config = [];
  tenantLogo: string;
  devices = [];
  languages = [];
  metaInfo: any;
  sessionid: string;
  servicecenters: any[];
  selectedServiceCenter: number;
  creditdetails?: { balance: number; used: number; limit: number };
  customertype?: string;
  repeatedawbdata?: any;
  groupkey?: UserGroupKey;
}

export enum UserGroupKey {
  SUPERADMIN = 'Super Admin',
  SYSTEMADMIN = 'System Admin',
  ADMIN = 'Portal Admin',
  FRANCHISESUPERADMIN = 'Franchise Super Admin',
  FRANCHISEADMIN = 'Franchise Admin',
  COMPANYADMIN = 'Company Admin',
  ACCOUNTS = 'Accounts',
  BILLING = 'Billing',
  SALESEXECUTIVE = 'Sales Executive',
  CUSTOMERSERVICE = 'Customer Service',
  DATAENTRY = 'Data Entry Operator',
  FIELDEXECUTIVE = 'Field Executive',
  CUSTOMERADMIN = 'Customer Admin',
  SHIPPERADMIN = 'Shipper Admin'
}


